import React from 'react';
import IDHelpers from '../../../core/helpers/IDHelper';
import { FullEmptyDates } from './fullEmptyDates';
import { TodayEmptyDates } from './todayEmptyDates';
import DateHelpers from '../../../core/helpers/DateHelper';
import TextHelper from '../../../core/helpers/TextHelper';
import { Heading } from './heading';
import { Item } from './item';
import { Block } from '..';

const AcademicDates = (props: any) => {
  const { datesForToday, datesForNextDays, idSelected } = props;
  const formatDates = (start: any, end: any) => {
    let dateFormated;
    if (start !== null && end !== null) {
      dateFormated = `${DateHelpers.getUTCDayWithFormat(
        start
      )} ${TextHelper.capitalize(
        DateHelpers.getShortMonthName(start)
      )} - ${DateHelpers.getUTCDayWithFormat(end)} ${TextHelper.capitalize(
        DateHelpers.getShortMonthName(end)
      )}`;

      if (start === end) {
        dateFormated = `${DateHelpers.getUTCDayWithFormat(
          start
        )} ${TextHelper.capitalize(DateHelpers.getShortMonthName(start))}`;
      }
    } else if (start != null) {
      dateFormated = `${DateHelpers.getUTCDayWithFormat(
        start
      )} ${TextHelper.capitalize(DateHelpers.getShortMonthName(start))}`;
    } else if (end != null) {
      dateFormated = `${DateHelpers.getUTCDayWithFormat(
        end
      )} ${TextHelper.capitalize(DateHelpers.getShortMonthName(end))}`;
    }

    return dateFormated;
  };

  return (
    <>
      {datesForToday && datesForNextDays ? (
        <>
          {datesForToday ? (
            datesForToday.map((collection: any) => (
              <Item
                key={IDHelpers.generateID()}
                idSelected={idSelected}
                id={collection.id}
                title={collection.title}
                dates={formatDates(collection.startDate, collection.endDate)}
                details={collection.description}
                target={collection.target || null}
              />
            ))
          ) : (
            <TodayEmptyDates />
          )}

          <Heading>Próximas fechas:</Heading>
          {datesForNextDays ? (
            datesForNextDays.map((collection: any) => (
              <Item
                className="items-academic-calendar"
                key={IDHelpers.generateID()}
                idSelected={idSelected}
                id={collection.id}
                title={collection.title}
                dates={formatDates(collection.startDate, collection.endDate)}
                details={collection.description}
                target={collection.target === '' ? '' : collection.target}
              />
            ))
          ) : (
            <Block />
          )}
        </>
      ) : (
        <FullEmptyDates />
      )}
    </>
  );
};

export default AcademicDates;
